<template>
  <div>
    <WriteSqlModal ref="WriteSqlModal" v-on:complete="writeSQLComplete"></WriteSqlModal>
    <Spin fix v-show="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>加载中</div>
    </Spin>
    <Alert v-if="error" show-icon type="error">获取数据失败<a style="float: right" v-on:click="resetForm">重新获取</a></Alert>
    <div style="margin-top: 5px" v-else>
      <Form inline ref="editForm" :model="editForm" :label-width="60">
        <FormItem label="名称">
          <Input v-model="editForm.name" style="width: 180px"/>
        </FormItem>
        <FormItem label="类型">
          <Select v-model="editForm.type" style="width: 100px" @on-change="typeChange">
            <Option label="过程" value='PROCEDURE'></Option>
            <Option label="函数" value='FUNCTION'></Option>
          </Select>
        </FormItem>
        <FormItem label="返回类型">
          <Select v-model="editForm.return_type" style="width: 180px" :disabled="editForm.type === 'PROCEDURE'" placeholder="">
            <Option :label="item.label" :value='item.value' v-for="(item, index) in returnTypeList" :key="index"></Option>
          </Select>
        </FormItem>
        <br/>
        <FormItem label="参数">
          <Input v-model="editForm.param_list" style="width: 600px"/>
        </FormItem>
        <br/>
        <FormItem label="定义者">
          <Input v-model="editForm.definer" style="width: 180px"/>
        </FormItem>
        <FormItem label="安全性">
          <Select v-model="editForm.security" style="width: 100px">
            <Option label="Definer" value='DEFINER'></Option>
            <Option label="Invoker" value='INVOKER'></Option>
          </Select>
        </FormItem>
        <FormItem label="数据访问">
          <Select v-model="editForm.data_access" style="width: 180px">
            <Option label="CONTAINS SQL" value='CONTAINS SQL'></Option>
            <Option label="NO SQL" value='NO SQL'></Option>
            <Option label="READS SQL DATA" value='READS SQL DATA'></Option>
            <Option label="MODIFIES SQL DATA" value='MODIFIES SQL DATA'></Option>
          </Select>
        </FormItem>
        <FormItem label="注释">
          <Input v-model="editForm.comment" style="width: 200px"/>
        </FormItem>
      </Form>
      <div class="ace-editor" :id="id"></div>
      <div class="info-edit-form-button">
        <Button type="primary" @click="ok" :loading="executing">提交</Button>
        <Button type="default" @click="resetForm" style="margin-left: 10px">重置</Button>
      </div>
    </div>
    <Modal title="执行结果" v-model="execResultModal" width="1000" footer-hide>
      <SQLResults ref="SQLResults" :callbackdata="callbackdata" :log="false"></SQLResults>
    </Modal>
  </div>
</template>

<script>
import { getFuncData, createFunc, alterFunc, executeSQL } from '@/api/mysql'
import SQLResults from './sqlResults'
import WriteSqlModal from './writeSqlModal'
import '@/view/database/ace-export'
import { iRandom } from '@/libs/tools'

export default {
  name: 'dbFuncEdit',
  components: {
    SQLResults,
    WriteSqlModal
  },
  data () {
    return {
      themePath: 'ace/theme/sqlserver',
      modePath: 'ace/mode/sql',
      aceEditor: '',
      old_data: {},
      editForm: {
        name: '',
        type: 'PROCEDURE',
        param_list: '',
        comment: '',
        definer: '',
        return_type: '',
        security: 'DEFINER',
        data_access: 'CONTAINS SQL'
      },
      id: 'edit-func-ace-editor' + iRandom(),
      execResultModal: false,
      executing: false,
      loading: false,
      error: false,
      returnTypeList: [
        {
          value: 'tinyint',
          label: 'tinyint'
        },
        {
          value: 'smallint',
          label: 'smallint'
        },
        {
          value: 'mediumint',
          label: 'mediumint'
        },
        {
          value: 'int',
          label: 'int'
        },
        {
          value: 'integer',
          label: 'integer'
        },
        {
          value: 'bigint',
          label: 'bigint'
        },
        {
          value: 'bit',
          label: 'bit'
        },
        {
          value: 'double',
          label: 'double'
        },
        {
          value: 'float',
          label: 'float'
        },
        {
          value: 'decimal',
          label: 'decimal'
        },
        {
          value: 'char',
          label: 'char'
        },
        {
          value: 'varchar',
          label: 'varchar'
        },
        {
          value: 'date',
          label: 'date'
        },
        {
          value: 'time',
          label: 'time'
        },
        {
          value: 'timestamp',
          label: 'timestamp'
        },
        {
          value: 'year',
          label: 'year'
        },
        {
          value: 'datetime',
          label: 'datetime'
        },
        {
          value: 'tinyblob',
          label: 'tinyblob'
        },
        {
          value: 'blob',
          label: 'blob'
        },
        {
          value: 'mediumblob',
          label: 'mediumblob'
        },
        {
          value: 'longblob',
          label: 'longblob'
        },
        {
          value: 'tinytext',
          label: 'tinytext'
        },
        {
          value: 'text',
          label: 'text'
        },
        {
          value: 'mediumtext',
          label: 'mediumtext'
        },
        {
          value: 'longtext',
          label: 'longtext'
        },
        {
          value: 'enum',
          label: 'enum'
        },
        {
          value: 'json',
          label: 'json'
        }
      ]
    }
  },
  props: {
    callbackdata: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  created: function () {
    if (this.callbackdata.func) {
      this.init()
    }
  },
  mounted: function () {
    this.aceEditor = ace.edit(this.id, {
      maxLines: 30,
      minLines: 20,
      fontSize: 14,
      value: '',
      theme: this.themePath,
      mode: this.modePath,
      wrap: 1,
      tabSize: 4
    })
    // 激活自动提示
    this.aceEditor.setOptions({
      enableSnippets: true,
      enableLiveAutocompletion: true,
      enableBasicAutocompletion: true,
      printMargin: false,
      printMarginColumn: 120
    })
    if (!this.callbackdata.func) {
      this.aceEditor.setValue('BEGIN\n' +
        '\t#Routine body goes here...\n' +
        '\n' +
        'END;')
    }
  },
  methods: {
    init () {
      let params = {
        id: this.callbackdata.instance_id,
        db: this.callbackdata.db,
        routine: this.callbackdata.func
      }
      this.loading = true
      this.error = false
      getFuncData(params).then(res => {
        if (res.data.routine.length) {
          const result = res.data.routine[0]
          this.editForm = result
          this.aceEditor.setValue(result.body)
          this.old_data = JSON.parse(JSON.stringify(result))
        }
        this.loading = false
      }).catch(res => {
        this.loading = false
      })
    },
    ok () {
      let reqData = {
        name: this.editForm.name,
        type: this.editForm.type,
        param_list: this.editForm.param_list,
        comment: this.editForm.comment,
        definer: this.editForm.definer,
        return_type: this.editForm.return_type,
        security: this.editForm.security,
        data_access: this.editForm.data_access,
        body: this.aceEditor.getValue()
      }
      if (!reqData.name) {
        this.$Notice.error({
          title: '名称是必填的！'
        })
        return false
      } else if (!reqData.body) {
        this.$Notice.error({
          title: '定义是必填的！'
        })
        return false
      } else if (reqData.type === 'FUNCTION' && !reqData.return_type) {
        this.$Notice.error({
          title: '请选择返回类型！'
        })
      }
      if (this.callbackdata.func) {
        let isDiff = false
        for (let i in reqData) {
          if (reqData[i] !== this.old_data[i]) {
            isDiff = true
            break
          }
        }
        if (isDiff) {
          reqData._old_name = this.old_data.name
          reqData._old_type = this.old_data.type
          alterFunc(reqData).then(res => {
            this.$refs.WriteSqlModal.open(res.data.sql, 'func')
          })
        } else {
          this.$Notice.warning({
            title: '没有任何修改！'
          })
        }
      } else {
        createFunc(reqData).then(res => {
          this.$refs.WriteSqlModal.open(res.data.sql, 'func')
        })
      }
    },
    resetForm () {
      this.editForm = {
        name: '',
        type: 'PROCEDURE',
        param_list: '',
        commit: '',
        definer: '',
        return_type: '',
        security: 'DEFINER',
        data_access: 'CONTAINS SQL'
      }
      this.aceEditor.setValue('')
      if (this.callbackdata.func) {
        this.init()
      }
    },
    writeSQLComplete (sql) {
      this.CreateSqlComplete(sql)
    },
    // 开始执行SQL
    CreateSqlComplete (sql) {
      let data = {
        id: this.callbackdata.instance_id,
        db: this.callbackdata.db,
        sql: sql,
        limit: '100'
      }
      let that = this
      that.executing = true
      executeSQL(data).then(res => {
        let results = []
        res.data.results.forEach(function (item, index) {
          if (item['success']) {
            that.$Notice.success({
              title: '操作成功',
              desc: item['msg']
            })
            if (!that.callbackdata.func) {
              let pushData = {
                tab_id: that.callbackdata.id,
                db: that.callbackdata.db,
                func: that.editForm.name
              }
              that.$emit('callBack', 'createFuncSuccess', pushData)
            } else {
              that.callbackdata.func = that.editForm.name
              that.init()
            }
          } else {
            that.$Notice.error({
              title: item['msg']
            })
          }
          results.push({'id': index + 1, 'res': item['data'], 'columns': [], 'msg': item['msg']})
          let cols = Object.keys(item['data'][0])
          if (cols) {
            cols.forEach(function (row) {
              results[index].columns.push({'title': row, 'key': row, 'minWidth': 130})
            })
          }
          that.execResultModal = true
        })
        that.executing = false
        that.$refs.SQLResults.showResult(results)
      }).catch(res => {
        that.executing = false
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.response
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    typeChange (type) {
      if (type === 'PROCEDURE') {
        this.editForm.return_type = ''
      }
    }
  }
}
</script>

<style scoped>
  .info-edit-form-button {
    background-color: #F5F7F9;
    text-align: center;
    height: 100px;
    display: block;
    line-height: 100px;
    margin-top: 10px;
  }
</style>
